import { DrawerId } from "components/CC/types/models";

interface SelectableNode {
    id: string;
    type?: string;
    data?: Record<string, unknown>;
}

interface SelectableEdge {
    id: string;
    source?: string;
    target?: string;
    data?: Record<string, unknown>;
}

const CC_NODE_DRAWER_IDS = new Set<DrawerId>([
    DrawerId.ModifyField,
    DrawerId.Set,
    DrawerId.HttpMethod,
    DrawerId.Http,
    DrawerId.Webhook,
    DrawerId.Start,
    DrawerId.End,
    DrawerId.Wait,
    DrawerId.Repeater,
    DrawerId.Breaker,
    DrawerId.SubScenario,
    DrawerId.Mirror,
]);

export const getCCDrawerSelectionParam = (drawerId: DrawerId) =>
    `${drawerId}-${drawerId === DrawerId.Condition ? "edgeId" : "stepId"}`;

export const isCCDrawerId = (value: string): value is DrawerId => {
    return Object.values(DrawerId).includes(value as DrawerId);
};

export const isCCNodeDrawerId = (drawerId: DrawerId) => CC_NODE_DRAWER_IDS.has(drawerId);

export const getNodeSelectionId = (node: SelectableNode): string => {
    const beId = node.data?.beId;
    return typeof beId === "string" && beId.length > 0 ? beId : node.id;
};

export const getEdgeSelectionId = (edge: SelectableEdge): string => {
    const beId = edge.data?.beId;
    return typeof beId === "string" && beId.length > 0 ? beId : edge.id;
};

export const findNodeBySelectionId = <T extends SelectableNode>(nodes: T[], selectionId: string): T | undefined => {
    return nodes.find((node) => getNodeSelectionId(node) === selectionId || node.id === selectionId);
};

export const findEdgeBySelectionId = <T extends SelectableEdge>(edges: T[], selectionId: string): T | undefined => {
    return edges.find((edge) => getEdgeSelectionId(edge) === selectionId || edge.id === selectionId);
};
